import {createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {rxInit} from "./appSlice";

const carsAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.position - b.position
});

const initialState = {
  cars: carsAdapter.getInitialState(),

  editor: {
    show: false,
    mode: null
  }
};

export const carsSlice = createSlice({
  name: "cars",
  initialState,
  reducers: {
    showEditor: (state, action) => {
      state.editor.show = true;
      state.editor.mode = action.payload.mode;
      state.editor.car = action.payload.car;
    },

    hideEditor: state => {
      state.editor.show = false;
    },

    submitEditor: (state, action) => {
      carsAdapter.setMany(state.cars, action.payload);
    },

    updateCars: (state, action) => {
      carsAdapter.setMany(state.cars, action.payload);
    },

    reorderCars: (state, action) => {
      let position = 1;

      carsAdapter.setMany(state.cars, action.payload.map(a => ({...a, position: position++})));
    }
  },
  extraReducers: builder => {
    builder.addCase(rxInit, (state, action) => {
      carsAdapter.setMany(state.cars, action.payload.cars);
    });
  }
});

export const {
  showEditor: rxShowCarEditor,
  hideEditor: rxHideCarEditor,
  submitEditor: rxSubmitCarEditor,
  updateCars: rxUpdateCars,
  reorderCars: rxReorderCars
} = carsSlice.actions;

export const {selectAll: selectAllCars} = carsAdapter.getSelectors(state => state.cars.cars);

export const editorConfigSelector = state => state.cars.editor;

export default carsSlice.reducer;
